import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/store'
import App from './App'
import routes from './routes'
import BootstrapVue from 'bootstrap-vue'
import "chart.js";
import "hchs-vue-charts";
Vue.use(window.VueCharts);

Vue.use(VueRouter)
Vue.use(BootstrapVue)

const router = new VueRouter({
    mode:'history',
    routes,
    linkActiveClass: 'active'
})


router.beforeEach((to, from, next) => {    
    store.commit("routeChange", "start");
    if(to.path=='/login')
        if(store.state.auth.idToken){            
            router.push(from.path)
            document.title = from.meta.title    
        }
        else      
            next()   
    else      
            next()   
})

router.afterEach((to, from) => {  
    store.commit("routeChange", "end");    
              
    if(store.state.auth.idToken && store.state.needToConfirmTAS){        
        if(to.path!='/confirmTAS')
            router.push('/confirmTAS')
    }
    else{
        document.title = to.meta.title        
        if (window.innerWidth < 992) {
            store.commit('left_menu', "close");
        } else {
            store.commit('left_menu', "close");
        }
    }
    try{      
        gtag('config', 'UA-1801250-8', {'page_title':document.title ,'page_path': to.path});
    }
    catch(e){}
})
new Vue({
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js